/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerSpecialCriteria } from './ScreenerSpecialCriteria';
import {
    ScreenerSpecialCriteriaFromJSON,
    ScreenerSpecialCriteriaFromJSONTyped,
    ScreenerSpecialCriteriaToJSON,
    ScreenerSpecialCriteriaToJSONTyped,
} from './ScreenerSpecialCriteria';

/**
 * 
 * @export
 * @interface UpdateSpecialCriteriaById200Response
 */
export interface UpdateSpecialCriteriaById200Response {
    /**
     * 
     */
    data?: ScreenerSpecialCriteria;
}

/**
 * Check if a given object implements the UpdateSpecialCriteriaById200Response interface.
 */
export function instanceOfUpdateSpecialCriteriaById200Response(value: object): value is UpdateSpecialCriteriaById200Response {
    return true;
}

export function UpdateSpecialCriteriaById200ResponseFromJSON(json: any): UpdateSpecialCriteriaById200Response {
    return UpdateSpecialCriteriaById200ResponseFromJSONTyped(json, false);
}

export function UpdateSpecialCriteriaById200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSpecialCriteriaById200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ScreenerSpecialCriteriaFromJSON(json['data']),
    };
}

export function UpdateSpecialCriteriaById200ResponseToJSON(json: any): UpdateSpecialCriteriaById200Response {
    return UpdateSpecialCriteriaById200ResponseToJSONTyped(json, false);
}

export function UpdateSpecialCriteriaById200ResponseToJSONTyped(value?: UpdateSpecialCriteriaById200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ScreenerSpecialCriteriaToJSON(value['data']),
    };
}

